/**
 * Wave 9 (post-Wave-8 frontend audit B4): footer now renders the
 * merchant's `support_email` + `portal_name` when configured.
 *
 * Wave 8 backend ships these via `/api/v1/public/shop-info` and
 * `/api/v1/branding/<slug>`; the Settings UI's "Support email (shown
 * in the portal footer)" copy promises this exact rendering. Pre-fix
 * the footer was a hardcoded copyright line — Scale+ merchants paying
 * for white-label saw zero difference from Free.
 *
 * Falls back to the hardcoded copy when no support_email is set so
 * Free/Growth-tier shops continue to render the default branding.
 *
 * "Powered by Kernvel" text suppressed when the shop has full
 * white-label (`tier_allows_white_label=true` reachable via the Wave
 * 8 admin branding panel) — but `useShopInfo`'s `PublicShopInfo` type
 * doesn't surface that flag (it's auth-gated, only on `/branding`
 * GET). For now we leave Kernvel attribution on; suppressing it
 * would need a follow-up endpoint extension. Tracked for Wave 10.
 */
import { useShopInfo } from '../../hooks/useShopInfo';
import { safeMailtoUrl } from '../../utils/safeUrls';

export function Footer() {
  const { shopInfo } = useShopInfo();
  const year = new Date().getFullYear();
  const portalName = shopInfo?.portal_name || 'Kernvel VendorIQ';
  const supportEmail = shopInfo?.support_email || '';
  const supportMailto = safeMailtoUrl(supportEmail);

  return (
    <footer className="border-t border-gray-200 bg-white px-4 py-3 text-center text-xs text-gray-500 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400">
      {supportMailto ? (
        <p>
          &copy; {year} {portalName} —{' '}
          Need help?{' '}
          <a
            href={supportMailto}
            className="underline hover:no-underline"
          >
            {supportEmail}
          </a>
        </p>
      ) : (
        <p>
          &copy; {year} {portalName} — Powered by Kernvel Labs
        </p>
      )}
    </footer>
  );
}
